// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"App_wrapper_pE_0j"};